// @flow
import * as React from 'react';
import Card from 'components/Card';
import SafariLandingPage from 'assets/SafariLandingPage.png';

const WYNG_REDIRECT_URL = 'https://wyng.com/auth/fix-safari-3rd-party-cookie/';

const SafariCookiePage = () => {
  const redirectWithReferrer = `${WYNG_REDIRECT_URL}?referrer=${
    window.location.href
  }`;

  return (
    <Card>
      <div className="ph6 pv4 flex flex-column items-center">
        <img className="w-75" src={SafariLandingPage} alt="" />
        <h1 className="tc b mt3 mb2 brandon" style={{ fontSize: 24 }}>
          Using Safari? One quick step to get started.
        </h1>
        <p className="tc fw1 mv2 lh-copy gray" style={{ fontSize: 16 }}>
          To use Social Collection with Safari, we need to set a one-time cookie
          for your browser. Simply click the link below to continue.
        </p>
        <a
          className="link mv2"
          style={{ fontSize: 16 }}
          href={redirectWithReferrer}
        >
          Refresh and Get Started
        </a>
      </div>
    </Card>
  );
};

export default SafariCookiePage;



// WEBPACK FOOTER //
// ./src/containers/socialcollection/SafariCookiePage.js